import styles from './Grid.module.css';

const colsMap = { 1: styles.cols1, 2: styles.cols2, 3: styles.cols3, 4: styles.cols4 };
const gapMap = { sm: styles.gapSm, md: styles.gapMd, lg: styles.gapLg };

interface GridProps {
  children: React.ReactNode;
  cols?: 1 | 2 | 3 | 4;
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Grid({ children, cols = 3, gap = 'md', className = '' }: GridProps) {
  return (
    <div className={[styles.grid, colsMap[cols], gapMap[gap], className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
